var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/pauseVideo.3f340a97.png","uri@2x": __webpack_public_path__ + "static/media/pauseVideo.a5b6ad74.png","uri@3x": __webpack_public_path__ + "static/media/pauseVideo.bbaa25df.png",
    width: 17,
    height: 20
});